import md5 from 'md5.js';
import * as React from 'react';
import Flex from './primitives/Flex';

interface IUserAvatarCustomProps {
  email?: string;
  size?: number;
  circular?: boolean;
}

const UserAvatar: React.FC<IUserAvatarCustomProps> = ({ email, size, circular }) => {
  if (!email) {
    return <div />;
  }
  const hash = new md5().update(email.toLowerCase())
    .digest('hex');
  return (
    <Flex
      border='1px solid white'
      borderColor='ui.primary.light'
      borderRadius={(circular) ? '50%' : 2}
      flex='0 0 auto'
      overflow='hidden'
    >
      <img
        height={size || 40}
        src={`https://www.gravatar.com/avatar/${hash}?d=retro`}
        style={{
          objectFit: 'cover',
        }}
        width={size || 40}
      />
    </Flex>
  );
};

export default UserAvatar;
